import apiUrl from "../../../constants";
import axios from "axios";
import Paginate from "vuejs-paginate";
import {
	Validator
} from "vee-validate";
import VueElementLoading from 'vue-element-loading';
import Pagination from './../shared/pagination'

export default {
	name: "role",
	components: {
		Paginate,
		Pagination,
		VueElementLoading
	},
	data: function() {
		return {
			totalRows:0,
			currentPage: 1,
			addpermissionmodal: false,
			modalShow: false,
			userpermissionaction: "",
			permissionname: "",
			fltpermissionname: "",
			purl: "",
			devicetype: '',
			controllerurl: '',
			parentid: '',
			permissionid: '',
			listUserPermissionmaster: [],
			listUserPermission: [],
			listUPermissionData: [],
			listPermissionData: [],
			// pageno: 0,
			pageLimit:10,
			totalPage: 0,
			perm_id: [],
			isLoading: false,
			resultCount: '',
			modaldata: '',
			modalindex: ''
		};
	},
	filters: {
		capitalize: function(value) {
			if (!value) return ''
			value = value.toString()
			return value.charAt(0).toUpperCase() + value.slice(1)
		},

	},

	mounted() {
		this.pageno = 0;
		this.getUserPermissionData();
		this.getParentList();
	},

	methods: {
		addNewUserPermission() {
			this.userpermissionaction = "add";
			this.addpermissionmodal = true;
			this.permissionid = '';
			this.permissionname = '';
			this.parentid = '';
			this.controllerurl = '';
			this.$validator.reset();
			this.errors.clear();
			this.clearNewForm();
		},

		//dropdown list  for getting parent name list and delete its child in dropdown menu
		getParentList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.listUserPermission = []
			this.input = ({
				permissionid: this.permissionid,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getParentOptions',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listUserPermission = result.data;
					this.listUserPermissionmaster = result.data;
				}, error => {
					console.error(error)
				})
		},

		getUserPermissionData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = {
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				permissionname: this.fltpermissionname,
			};
			this.isLoading = true;
			axios({
				method: "POST",
				url: apiUrl.api_url + "getUserPermissionList",
				data: this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			}).then(
				result => {
					this.listUPermissionData = result.data.rows;
					this.isLoading = false;
					this.totalRows = result.data.count;
					this.resultCount = result.data.count
					if (this.totalRows < 10) {
						this.totalPage = 1;
					} else {
						this.totalPage = Math.ceil(this.totalRows / 10);
					}
				},
				error => {
					console.error(error);
				}
			);
		},

		getUserPermissionDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.getUserPermissionData();
		},

		saveUserPermission() {
			if (this.permissionname == '' || this.permissionname == null) {
				return false;
			}
			if (this.devicetype == '' || this.devicetype == null) {
				return false;
			}
			this.isLoading = true;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: "POST",
					url: apiUrl.api_url + "saveUserPermission",
					data: {
						permissionname: this.permissionname,
						parentid: Number(this.parentid),
						controllerurl: this.controllerurl,
						purl: this.purl,
						devicetype: this.devicetype
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(response => {
					if (response.data.errorCode == 0) {
						this.$alertify.success("User Permission Created Successfully")
						this.clearNewForm();
						this.addpermissionmodal = false
						this.getUserPermissionData();
					} else {
						(response.data.errorCode == -1)
						this.$alertify.error("User-Permission Already Existed ")
					}
					this.isLoading = false;
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		getUserRowData(data) {
			this.modalShow = false;
			this.userpermissionaction = "edit";
			this.permissionname = data.permissionname;
			this.controllerurl = data.controllerurl;
			this.parentid = data.parentid;
			this.purl = data.purl;
			this.devicetype = data.devicetype;
			this.permissionid = data.permissionid;
			this.addpermissionmodal = true;
			this.$validator.reset();
			this.listUserPermission = this.listUserPermissionmaster.filter(function(pm) {
				return pm.permissionid != data.permissionid
			});
		},

		editUserPermission() {
			if (!this.parentid) {
				this.parentid = 0
			}
			if (!this.controllerurl) {
				this.controllerurl = ''
			}
			if (!this.purl) {
				this.purl = ''
			}
			if (this.permissionname == '' || this.permissionname == null) {
				return false;
			}
			if (this.devicetype == '' || this.devicetype == null) {
				return false;
			}
			this.isLoading = true;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: "POST",
					url: apiUrl.api_url + "updateUserPermission",
					data: {
						permissionname: this.permissionname,
						permissionid: Number(this.permissionid), //change
						parentid: Number(this.parentid),
						controllerurl: this.controllerurl,
						purl: this.purl,
						devicetype: this.devicetype
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(response => {
					if (response.data.errorCode == 0) {
						this.$alertify.success("User Permission Updated Successfully")
						this.addpermissionmodal = false
						this.getUserPermissionData();
					} else {
						(response.data.errorCode == -1)
						this.$alertify.error("User Permission Updation Failed ")
					}
					this.isLoading = false;
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		closeAddPermissionModal() {
			this.addpermissionmodal = false;
			this.$validator.reset();
			this.errors.clear();
			this.resetform();
		},
		// close delete model
		closeDeleteModal() {
			this.modalShow = false
		},
		// delete popup modal
		openDeleteModal(data, index) {
			this.modaldata = data
			this.modalindex = index
			this.modalShow = true
		},

		clearNewForm() {
			this.purl = '',
				this.devicetype = '',
				this.permissionid = '',
				this.permissionname = '',
				this.parentid = '',
				this.controllerurl = '';
		},

		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * 10;
		// 	this.getUserPermissionData();
		// },
		onPageChange(page) {
		  this.currentPage = page;
		  this.getUserPermissionData()
		},
		deleterow() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var permissionid = this.modaldata.permissionid;
			var index = this.modalindex;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'deleteUserPermissionDetails',
					'data': {
						"permissionid": Number(permissionid),
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.data.errorCode == 0) {
						this.listUPermissionData.splice(index, 1);
						this.$alertify.success("User Permission Deleted Successfully")
						this.getUserPermissionData()
					}
				});
		},

		resetform() {
			this.$validator.reset();
			this.errors.clear();
			this.totalRows=0;
			this.fltpermissionname = '';
			this.getUserPermissionData();
		},

		onSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (result) {
					console.log('form is valid', this.model);
					event.target.reset();
				} else {
					return false;
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		}
	}
};



// WEBPACK FOOTER //
// ./src/views/components/userpermissions/userpermissions.component.js